import { render, staticRenderFns } from "./khgl.vue?vue&type=template&id=bef1f488&"
import script from "./khgl.vue?vue&type=script&lang=js&"
export * from "./khgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports